import React from 'react';
import PropTypes from 'prop-types';
import { ProfileSettingsConfig } from '@Constants/rx-user/constants';
import { EMAIL_ERRORS, validateEmailWithErrors } from '@Utils/Email';
import ProfileSettingsInputSection from '@Pages/ProfileSettings/Components/ProfileSettingsInputSection';

const emailErrorsMessages = {
  [EMAIL_ERRORS.REQUIRED]: 'Please choose a new email.',
  [EMAIL_ERRORS.CHECK_EMAIL]: `Please provide a valid email address.`,
};

const FIELD_NAME = 'profile-settings-account-email';

function EmailSection({ value, onChange, onSave, onClose, trackAdobeAnalyticsError }) {
  return (
    <ProfileSettingsInputSection
      name={FIELD_NAME}
      label={ProfileSettingsConfig.Labels.email}
      title={ProfileSettingsConfig.LinkText.email}
      value={value}
      errorsMessages={emailErrorsMessages}
      validate={validateEmailWithErrors}
      onChange={onChange}
      onSave={onSave}
      onClose={onClose}
      onBlur={trackAdobeAnalyticsError}
    />
  );
}

EmailSection.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  trackAdobeAnalyticsError: PropTypes.func.isRequired,
};

export default EmailSection;
